@if (isArea) {
    <cerrix-textarea
        id="field-{{ field.ID }}"
        [(ngModel)]="answer"
        (keyupEvent)="fieldChange()"
        [disabled]="readonly"
        [readonly]="readonly"
        inputTooltip
    ></cerrix-textarea>
} @else {
    <cerrix-textfield
        id="field-{{ field.ID }}"
        [(ngModel)]="answer"
        (keyupEvent)="fieldChange()"
        [disabled]="readonly"
        [readonly]="readonly"
    ></cerrix-textfield>
}
